import { Box, Flex } from '@chakra-ui/react';
import { components } from 'react-select';
import { KText } from '@/ui-library/components/text';
import { useKFlags } from '@/hooks/use-k-flags';

const hasSurveyLink = (templateBody: string) => {
  return templateBody?.includes('{{survey.link}}');
};

const hasSurveyBadge = (isFocused = false, isSelected = false) => {
  const bgColor = isFocused || isSelected ? 'secondary-200' : 'pastel-5-light';
  const textColor = 'pastel-5-dark';

  return (
    <Flex
      className="has-survey-badge"
      bg={bgColor}
      borderRadius="4px"
      p="4px 8px"
    >
      <KText
        className="has-survey-badge-text"
        lineHeight="16px"
        size="sm-regular"
        color={textColor}
      >
        Has survey
      </KText>
    </Flex>
  );
};

export const CustomOption = (props) => {
  const { data, isFocused, isSelected } = props;
  const { feSurvey } = useKFlags();
  const hasSurvey = feSurvey && hasSurveyLink(data?.body);

  return (
    <components.Option {...props}>
      <Flex alignItems="center" gap={2}>
        <Box>{data?.name || data?.label}</Box>
        {hasSurvey && hasSurveyBadge(isFocused, isSelected)}
      </Flex>
    </components.Option>
  );
};

export const CustomSingleValue = (props) => {
  const { data, isFocused, isSelected } = props;
  const { feSurvey } = useKFlags();
  const hasSurvey = feSurvey && hasSurveyLink(data?.body);

  return (
    <components.SingleValue {...props}>
      <Flex alignItems="center" gap={2}>
        <Box>{data?.name || data?.label}</Box>
        {hasSurvey && hasSurveyBadge(isFocused, isSelected)}
      </Flex>
    </components.SingleValue>
  );
};
